import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: `${Routes.CONFIRM_RECIPIENT}/:email/:projectId`,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/ConfirmRecipientContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'confirmRecipient', reducer: reducer.default })

    cb(null, module.default)
  }
})
